import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";
import SearchParams from "../searchParams";

export const messages = (api: API) => ({
  createThread(
    data: OpenAPI.POST<`/messages/threads`>["requestBody"],
    success: (data: OpenAPI.POST<`/messages/threads`>["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("POST", "/messages/threads", data, success, fail);
  },
  getThreads(
    data: OpenAPI.GET<`/messages/threads`>["parameters"]["query"],
    success: (data: OpenAPI.GET<`/messages/threads`>["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(data).toString();
    api.authenticatedRequest(
      "GET",
      `/messages/threads?${queryParams}`,
      null,
      success,
      fail,
    );
  },
  getThread(
    id: string,
    success: (data: OpenAPI.GET<`/messages/threads/{id}`>["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/messages/threads/${id}`,
      null,
      (data) => success?.(data),
      fail,
    );
  },
  muteThread(
    id: string,
    toMute: boolean,
    success: (
      data: OpenAPI.PUT<`/messages/threads/{id}/mute`>["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      toMute ? "PUT" : "DELETE",
      `/messages/threads/${id}/mute`,
      null,
      success,
      fail,
    );
  },
  leaveThread(
    id: string,
    success: (
      data: OpenAPI.DELETE<`/messages/threads/{id}`>["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/messages/threads/${id}`,
      null,
      success,
      fail,
    );
  },
  updateThread(
    id: string,
    data: OpenAPI.POST<`/messages/threads/{id}/update`>["requestBody"],
    success: (
      data: OpenAPI.POST<`/messages/threads/{id}/update`>["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/messages/threads/${id}/update`,
      data,
      ({ thread }) => success(thread),
      fail,
    );
  },
  findThreads(
    data: OpenAPI.POST<`/messages/threads/search`>["requestBody"],
    success: (
      data: OpenAPI.POST<`/messages/threads/search`>["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      "/messages/threads/search",
      data,
      success,
      fail,
    );
  },
  findThreadByUser(
    userId: string,
    success: (
      data: OpenAPI.GET<`/messages/users/{id}/threads`>["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/messages/users/${userId}/threads`,
      null,
      (data) => success?.(data),
      fail,
    );
  },
  send(
    id: string,
    content: string,
    success: (data: OpenAPI.POST<`/messages/threads/{id}`>["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/messages/threads/${id}`,
      { content },
      success,
      fail,
    );
  },
  getMessageThread(
    id: string,
    success: (
      data: OpenAPI.GET<`/messages/threads/{id}/messageThread`>["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/messages/threads/${id}/messageThread`,
      null,
      success,
      fail,
    );
  },
  markAsSeen(
    messageThreads: string[],
    markAllAsSeen: boolean,
    success: (data: OpenAPI.PUT<`/messages/threads/seen`>["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      "/messages/threads/seen",
      { messageThreads, markAllAsSeen },
      success,
      fail,
    );
  },
});
